import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-y-12 sm:gap-y-4 w-full max-w-lg mx-auto h-[100vh] pt-4 sm:pt-1 sm:justify-around"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full max-w-lg mx-auto h-[100vh] justify-around"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_Success = _resolveComponent("Success")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_FrontTile = _resolveComponent("FrontTile")!
  const _component_KeyBoard = _resolveComponent("KeyBoard")!
  const _component_SettingsPage = _resolveComponent("SettingsPage")!
  const _component_InfoPage = _resolveComponent("InfoPage")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["appWrapper w-full h-full scene_element bg-[#f6f6f6]", { appDarkmode: _ctx.darkMode }])
  }, [
    (_ctx.layout.main)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_TopBar, {
            layout: _ctx.layout,
            darkMode: _ctx.darkMode,
            toggleDarkMode: _ctx.toggleDarkMode
          }, null, 8, ["layout", "darkMode", "toggleDarkMode"]),
          (_ctx.success.success === true)
            ? (_openBlock(), _createBlock(_component_Success, {
                key: 0,
                gridImage: _ctx.gridImage,
                handlesPopUp: _ctx.handlesPopUp,
                theDate: _ctx.theDate,
                outToggle: _ctx.outToggle,
                toggleOut: _ctx.toggleOut
              }, null, 8, ["gridImage", "handlesPopUp", "theDate", "outToggle", "toggleOut"]))
            : _createCommentVNode("", true),
          (_ctx.statistics.statistics === true)
            ? (_openBlock(), _createBlock(_component_Statistics, {
                key: 1,
                gridImage: _ctx.gridImage,
                wordoftheday: _ctx.wordoftheday,
                handlesPopUp: _ctx.handlesPopUp,
                theDate: _ctx.theDate,
                outToggle: _ctx.outToggle,
                toggleOut: _ctx.toggleOut
              }, null, 8, ["gridImage", "wordoftheday", "handlesPopUp", "theDate", "outToggle", "toggleOut"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["mt-5 sm:mt-14 relative flex flex-col gap-y-4", {
          'opacity-50': _ctx.statistics.statistics || _ctx.success.success,
        }])
          }, [
            (_ctx.wiggle.wiggle === true)
              ? (_openBlock(), _createBlock(_component_Popup, {
                  key: 0,
                  popUpValue: _ctx.popUpValue
                }, null, 8, ["popUpValue"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.word, (row, index) => {
              return (_openBlock(), _createBlock(_component_FrontTile, {
                key: row.id,
                row: row,
                currentRow: _ctx.currentRow,
                wiggle: _ctx.wiggle,
                darkMode: _ctx.darkMode,
                rowIndex: ++index
              }, null, 8, ["row", "currentRow", "wiggle", "darkMode", "rowIndex"]))
            }), 128))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-wrap gap-2 justify-center px-1 sm:px-1 pt-3 sm:pt-0 KeyBoardWrapper", {
          darkModeKeyboard: _ctx.darkMode,
          'opacity-50': _ctx.statistics.statistics || _ctx.success.success,
        }])
          }, [
            _createVNode(_component_KeyBoard, {
              makeGuess: _ctx.makeGuess,
              gamerKeyBoard: _ctx.gamerKeyBoard,
              removeChar: _ctx.removeChar,
              enterKey: _ctx.enterKey
            }, null, 8, ["makeGuess", "gamerKeyBoard", "removeChar", "enterKey"])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.layout.settings || _ctx.layout.info)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.layout.settings)
            ? (_openBlock(), _createBlock(_component_SettingsPage, {
                key: 0,
                layout: _ctx.layout,
                darkMode: _ctx.darkMode,
                toggleDarkMode: _ctx.toggleDarkMode,
                handlesPopUp: _ctx.handlesPopUp
              }, null, 8, ["layout", "darkMode", "toggleDarkMode", "handlesPopUp"]))
            : _createCommentVNode("", true),
          (_ctx.layout.info)
            ? (_openBlock(), _createBlock(_component_InfoPage, {
                key: 1,
                layout: _ctx.layout,
                darkMode: _ctx.darkMode
              }, null, 8, ["layout", "darkMode"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}